import React, { useContext, useState } from 'react';
import '../App.css';
import SpButton from '../components/atoms/SpButton';
import { useHistory } from 'react-router';
import { withSnackbar } from '../components/atoms/SpSnackBar';
import { Grid } from '@material-ui/core';
import { useEffect } from 'react';
import { UserSessionContext } from '../App';
import { createPaymentAccount, getPaymentAccount } from '../models/actions/PaymentsAccount';

const Dashboard = (props) => {
  //Hooks
  const history = useHistory();
  const userContext = useContext(UserSessionContext);
  const [accountPaymentDetails, setAccountPaymentDetails] = useState();
  const { authData, setAuthData } = useContext(UserSessionContext);

  useEffect(async () => {
    try {
      const accountDetails = await getPaymentAccount({ user_id: authData.userId }, authData.accessToken);
      setAccountPaymentDetails(accountDetails);
    } catch (error) {
      console.error(error);
    }
  }, []);

  const createStripeAccount = async () => {
    try {
      if (!accountPaymentDetails) {
        const { accountLink } = await createPaymentAccount({ user_id: authData.userId }, authData.accessToken);
        window.open(accountLink);
      } else {
        window.open('https://dashboard.stripe.com/dashboard');
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Grid
        item
        container
        direction={'column'}
        spacing={2}
        justifyContent="flex-start"
        alignItems={'center'}
      >
        <Grid
          item
          xs={3}
        >
          <SpButton
            variant="standardMax"
            text={'STAZIONI'}
            onClick={() => history.push('/stations')}
          />
        </Grid>
        <Grid
          item
          xs={3}
        >
          <SpButton
            variant="standardMax"
            text={'PUNTI DI INTERESSE'}
            onClick={() => history.push('/point-of-interest')}
          />
        </Grid>
        <Grid
          item
          xs={3}
        >
          <SpButton
            variant="standardMax"
            text={'PERCORSI'}
            onClick={() => history.push('/trails')}
          />
        </Grid>
        <Grid
          item
          xs={3}
        >
          <SpButton
            variant="standardMax"
            text={accountPaymentDetails ? 'ACCEDI ALLA DASHBOARD STRIPE' : 'COLLEGA IL TUO ACCOUNT STRIPE'}
            onClick={() => createStripeAccount()}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default withSnackbar(Dashboard);
